export const PRODUCT_IMAGE_PLACEHOLDER = '/images/product-image-placeholder.svg';
export const INNER_TUBE_IMAGE_PLACEHOLDER = '/uploads/images/ic-lastik.jpg';

export function getProductImagePlaceholder(category?: unknown): string {
    const categoryName = typeof category === 'string'
        ? category
        : category && typeof category === 'object'
            ? (category as { name?: string; slug?: string }).name
                || (category as { slug?: string }).slug
                || ''
            : '';
    const normalizedCategory = categoryName
        .normalize('NFD')
        .toLowerCase()
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[-_]/g, ' ');

    return normalizedCategory.includes('ic lastik')
        ? INNER_TUBE_IMAGE_PLACEHOLDER
        : PRODUCT_IMAGE_PLACEHOLDER;
}
